import './FilterDropdown.scss';
import cn from 'classnames';
import { PropsWithChildren, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { MdFilterListAlt } from 'react-icons/md';

interface FilterDropdownProps extends PropsWithChildren {
  /** Column label shown in the dropdown title */
  label: string;
  /** Whether the column currently has an active filter (highlights the icon) */
  active: boolean;
  /** Renders the icon in a disabled style (dropdown still opens) */
  disabled?: boolean;
  /** Extra class for the dropdown menu */
  menuClassName?: string;
}

/**
 * Shared shell for column filter dropdowns: filter icon toggle + titled menu.
 * Filter-specific controls render as children.
 */
export const FilterDropdown = ({
  label,
  active,
  disabled = false,
  menuClassName = '',
  children
}: FilterDropdownProps) => {
  const [show, setShow] = useState(false);

  return (
    <Dropdown show={show} onToggle={setShow}>
      <Dropdown.Toggle
        as='div'
        className={cn('filter-icon', { disabled, active: !disabled && active })}
        onClick={() => setShow(!show)}
      >
        <MdFilterListAlt />
      </Dropdown.Toggle>

      <Dropdown.Menu className={cn('filter-dropdown-menu', menuClassName)}>
        <div className='filter-header'>
          <div className='filter-title'>Local Filter For &apos;{label}&apos;</div>
        </div>
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};
